export default "__VITE_ASSET__DG0FOHup__"